const hrefLink = (text, link) => {
    return (
        <a class = "text-blue-500 hover:text-blue-800" href = {link}>
            {text}
        </a>
    );
  };

export default hrefLink;